import { Component, Input } from '@angular/core'
import { IHandlerOperation } from 'src/app/models/HandlerOperation'
import { HandlerOperations, Section } from 'src/app/models/Reports'

@Component({
	selector: 'app-legal-fundamentations',
	templateUrl: './legal-fundamentations.component.html'
})
export class LegalFundamentationsComponent {
		@Input() public managementForCompany: Array<IHandlerOperation> = []
		@Input() public managementRecommendations: Array<HandlerOperations> = []
		@Input() public disabled: boolean = true

		public indexManagementToEditSections: number = 0
		public sectionFromManagmentSelected: Array<Section> = []
		public showSelectSections: boolean = false

		public openSelectorSections(managementSelected: HandlerOperations) {

				const findSectionsFromManagementSelected =
						this.managementForCompany.find(management =>
								management._id == managementSelected.idMongo
						).sections

				const indexSelected: number =
						this.managementRecommendations.findIndex(management =>
								management.idMongo == managementSelected.idMongo
						)

				if (findSectionsFromManagementSelected) {
						this.showSelectSections = true
						this.indexManagementToEditSections = indexSelected
						this.sectionFromManagmentSelected = findSectionsFromManagementSelected
				}
		}

		public closeSelectorSections(
		event: Array<Section>
	) {
		this.showSelectSections = false
		this.managementRecommendations[this.indexManagementToEditSections].sections = event
	}

		public getManagementWithLegalFundamentation(): Array<IHandlerOperation> {
				return this.managementRecommendations.filter(handlerOperation =>
						handlerOperation.legalFundamentation
				)
		}
}
